(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tmh-avant-apres"] && !Shopify.designMode) return;
  try {
    
  class ComparateurAvantApres extends HTMLElement {
    connectedCallback() {
      const curseur = this.querySelector('input[type="range"]');
      if (!curseur) return;

      // Une seule ecriture, sur une variable CSS : le navigateur n'a que le
      // clip-path a recalculer, jamais la mise en page.
      const poser = () => this.style.setProperty('--tmh-pos', curseur.value + '%');
      curseur.addEventListener('input', poser);

      const deplacerVers = (clientX) => {
        const cadre = this.getBoundingClientRect();
        if (cadre.width === 0) return;
        const brut = ((clientX - cadre.left) / cadre.width) * 100;
        curseur.value = String(Math.min(100, Math.max(0, brut)));
        poser();
      };

      // ── Souris et stylet ──
      let saisi = false;

      this.addEventListener('pointerdown', (ev) => {
        if (ev.pointerType === 'touch') return;
        // Coupe le glisser-deposer natif de l'image AVANT qu'il ne demarre : il
        // emettait un pointercancel qui figeait la ligne apres un seul cran.
        ev.preventDefault();
        saisi = true;
        try {
          this.setPointerCapture(ev.pointerId);
        } catch {}
        deplacerVers(ev.clientX);
      });

      this.addEventListener('pointermove', (ev) => {
        if (saisi && ev.pointerType !== 'touch') deplacerVers(ev.clientX);
      });

      const relacher = (ev) => {
        saisi = false;
        try {
          this.releasePointerCapture(ev.pointerId);
        } catch {}
      };
      this.addEventListener('pointerup', relacher);
      this.addEventListener('pointercancel', relacher);

      // ── Doigt ──
      //
      // Un chemin a part, et non les seuls evenements de pointeur. Avec
      // touch-action: pan-y, Chromium rend le pointerdown tactile NON
      // annulable et peut reclamer le geste pour son propre defilement : la
      // ligne ne suivait pas le doigt. Les evenements tactiles, eux, se
      // laissent annuler explicitement.
      let depart = null;

      this.addEventListener('touchstart', (ev) => {
        const t = ev.touches[0];
        if (!t) return;
        depart = { x: t.clientX, y: t.clientY, horizontal: false };
      }, { passive: true });

      this.addEventListener('touchmove', (ev) => {
        const t = ev.touches[0];
        if (!t || !depart) return;

        // On n'accapare le geste qu'une fois sa direction claire : un glisse
        // vertical doit rester au defilement de la page, sinon le visiteur
        // mobile se retrouve enferme dans la section.
        if (!depart.horizontal) {
          const dx = Math.abs(t.clientX - depart.x);
          const dy = Math.abs(t.clientY - depart.y);
          if (dx < 8 && dy < 8) return;
          if (dy > dx) {
            depart = null;
            return;
          }
          depart.horizontal = true;
        }

        if (ev.cancelable) ev.preventDefault();
        deplacerVers(t.clientX);
      }, { passive: false });

      const finirTactile = () => {
        depart = null;
      };
      this.addEventListener('touchend', finirTactile, { passive: true });
      this.addEventListener('touchcancel', finirTactile, { passive: true });

      poser();
    }
  }

  if (!customElements.get('tmh-avant-apres')) {
    customElements.define('tmh-avant-apres', ComparateurAvantApres);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tmh-avis-accueil"] && !Shopify.designMode) return;
  try {
    
  /* Les flèches font défiler le rail d'une carte. Délégué depuis le document :
     l'éditeur de thème recharge la section sans recharger la page, et un
     écouteur posé sur les boutons d'origine resterait accroché à des nœuds
     retirés. Les flèches ne s'affichent que si le rail déborde. */
  (function () {
    function rafraichir(racine) {
      var rail = racine.querySelector('[data-tmh-rail]');
      if (!rail) return;
      var deborde = rail.scrollWidth > rail.clientWidth + 2;
      racine.classList.toggle('tmh-avis-accueil--deborde', deborde);
      var debut = rail.scrollLeft <= 2;
      var fin = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      racine.querySelectorAll('[data-tmh-defiler]').forEach(function (b) {
        b.disabled = b.getAttribute('data-tmh-defiler') === '-1' ? debut : fin;
      });
    }

    function tout() {
      document.querySelectorAll('[data-tmh-avis-accueil]').forEach(rafraichir);
    }

    document.addEventListener('click', function (e) {
      var bouton = e.target.closest && e.target.closest('[data-tmh-defiler]');
      if (!bouton) return;
      var racine = bouton.closest('[data-tmh-avis-accueil]');
      var rail = racine && racine.querySelector('[data-tmh-rail]');
      var carte = rail && rail.querySelector('li');
      if (!carte) return;
      var pas = carte.getBoundingClientRect().width + 20;
      rail.scrollBy({ left: pas * Number(bouton.getAttribute('data-tmh-defiler')), behavior: 'smooth' });
    });

    document.addEventListener('scroll', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-tmh-rail]')) {
        rafraichir(e.target.closest('[data-tmh-avis-accueil]'));
      }
    }, true);

    window.addEventListener('resize', tout);
    document.addEventListener('shopify:section:load', tout);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
    else tout();
  })();

  } catch(e) { console.error(e); }
})();
})();
